module.exports = __webpack_public_path__ + "img/让作品直接链接市场水印.37b410e6.png";